import { observable } from 'mobx';

import { AnalyticsStore, SerializedData, Store } from 'bernie-core';

import { DialogForcedChoiceLodgingCrossSell, DialogType } from 'types/search/dialogs';
import { InputValidator } from 'stores/validators';
import { trackAnalytics } from 'utility';
import { FlightsSearchFormDateFieldType, FlightsSearchFormError } from 'types/search/wizard';
import { FlightsSearchFormErrorType } from '__generated__/api';

export class DialogsStore extends Store {
  @observable public dialogs: DialogType[]; //TODO: Refer to Graphql type
  @observable public forcedChoiceDisplayedCounter: number;

  public dialogsStoreInitialState: SerializedData;

  public setDialogsStoreInitialState(): void {
    this.dialogsStoreInitialState = this.toJSON();
  }

  public resetForcedChoiceModelErrors = () => {
    const { checkInDate, checkOutDate } = this.getForcedChoiceModalDialog();
    checkInDate.currentError = null;

    if (checkOutDate) {
      checkOutDate.currentError = null;
    }
  };

  public hydrate(data: SerializedData): void {
    Object.assign(this, data);
  }

  public getForcedChoiceModalDialog = () =>
    this.dialogs &&
    (this.dialogs.find(
      dialog => dialog.__typename === 'FlightsDialogForcedChoiceLodgingCrossSell'
    ) as DialogForcedChoiceLodgingCrossSell);

  public getInitialForcedChoiceModalDialog = () =>
    this.dialogsStoreInitialState &&
    this.dialogsStoreInitialState.dialogs &&
    (this.dialogsStoreInitialState.dialogs.find(
      dialog => dialog.__typename === 'FlightsDialogForcedChoiceLodgingCrossSell'
    ) as DialogForcedChoiceLodgingCrossSell);

  public validateForcedChoiceModal(analyticsStore: AnalyticsStore): boolean {
    let valid = true;
    this.resetForcedChoiceModelErrors();
    const { checkInDate, checkOutDate } = this.getForcedChoiceModalDialog();
    const defaultCheckInDate =
      this.getInitialForcedChoiceModalDialog() && this.getInitialForcedChoiceModalDialog().checkInDate;

    valid = this.validateDate(checkInDate, defaultCheckInDate, checkOutDate, analyticsStore);
    valid = this.validateDate(checkOutDate, defaultCheckInDate, checkInDate, analyticsStore) && valid;

    return valid;
  }

  private validateDate(
    dateToValidate: FlightsSearchFormDateFieldType,
    defaultStartDate: FlightsSearchFormDateFieldType,
    otherSelectedDate: FlightsSearchFormDateFieldType,
    analyticsStore: AnalyticsStore
  ): boolean {
    let valid = true;

    dateToValidate.possibleErrors.every(error => {
      let passValidation = true;
      if (error.type === FlightsSearchFormErrorType.MAX_STAY_DURATION_ERROR) {
        passValidation = InputValidator.DATE.MAX_STAY_DURATION_ERROR(otherSelectedDate, dateToValidate);
      } else {
        const validator = InputValidator.DATE[error.type] as (
          dateA: FlightsSearchFormDateFieldType,
          dateB?: FlightsSearchFormDateFieldType
        ) => boolean;
        passValidation = validator ? validator(dateToValidate, defaultStartDate) : true;
      }
      if (!passValidation) {
        const errorMessage = this.getErrorMessage(defaultStartDate, error);
        dateToValidate.currentError = errorMessage;
        trackAnalytics(error.analytics, analyticsStore);
        valid = false;
      }

      return valid;
    });

    return valid;
  }

  private getErrorMessage = (defaultDate: FlightsSearchFormDateFieldType, error: FlightsSearchFormError) => {
    if (error && defaultDate) {
      switch (error.type) {
        case FlightsSearchFormErrorType.DATE_NOT_IN_VALID_RANGE_TO_DEFAULT_DATE:
          return error.message.replace('{defaultCheckInDate}', defaultDate.date.formatted);
        default:
          return error.message;
      }
    }
  };

  public incrementForcedChoiceDisplayedCounter = () => {
    this.forcedChoiceDisplayedCounter++;
  };

  public resetForcedChoiceDisplayedCounter = () => {
    this.forcedChoiceDisplayedCounter = 0;
  };
}

DialogsStore.DEFAULTS = {
  dialogs: [],
  forcedChoiceDisplayedCounter: 0
};
